import { Autocomplete, TextField } from '@mui/material';

type Props = {
  value: string;
  id: number;
  update: (id: number, value: string) => void;
  forceFocus?: boolean;
  label?: string;
};

function HierarcheyLevelSelector({
  value,
  id,
  update,
  forceFocus = true,
  label = '',
}: Props) {
  const options = ['', '1次請け', '2次請け', '3次請け'];

  return (
    <Autocomplete
      options={options}
      value={value || ''}
      onChange={(_, newValue) => {
        const numericValue = newValue ? parseInt(newValue.toString().charAt(0), 10) : null;
        update(id, numericValue ? String(numericValue) : null);
      }}
      onBlur={(event) => {
        const newValue = (event.target as HTMLInputElement).value;
        const numericValue = newValue ? parseInt(newValue.toString().charAt(0), 10) : null;
        update(id, numericValue ? String(numericValue) : null);
      }}
      openOnFocus
      renderInput={(inputParams) => (
        <TextField
          {...inputParams}
          margin="dense"
          type="text"
          label={label}
          InputLabelProps={{ shrink: true }}
          fullWidth
          variant="standard"
          inputRef={(input: HTMLInputElement | null) => {
            if (!forceFocus) return;

            if (input) {
              input.focus();
            }
          }}
        />
      )}
      sx={{
        width: '100%', // Autocomplete の幅を横いっぱいに広げる
      }}
    />
  );
}

export default HierarcheyLevelSelector;
